import { Fragment, useState, useEffect, useCallback, useRef, useMemo, useLayoutEffect } from 'react';
import { Layout, Form, Row, Col, Button, Space, Table, TreeSelect, Radio, DatePicker, message, Select, Flex, Tooltip, Card, theme } from 'antd';
import { filterFormItemLayout, filterFormGridLayout, filterFormItemStyle, computeButtonColLayout, fullPagerConfig } from '@utils/property';
import { useNavigate } from 'react-router-dom';
import dayjs from 'dayjs';
import { get } from '@/core/request';
import PageHeader from '@components/PageHeader/PageHeader';
import { useHorizontalScrollGuard } from '@/hooks/useHorizontalScrollGuard';
import { useTableScrollY } from '@/hooks/useTableScrollY';
import { useVerticalScrollShadow } from '@/hooks/useVerticalScrollShadow';
import { useEnableTableScrollYLayout } from '@/layouts/tableScrollLayout';
import { useFilterPanelVisible } from '@/hooks/useFilterPanelVisible';
import './Surveys.less';

const { Option } = Select;

export default function BiChannelSurveys() {
    const { token } = theme.useToken();
    const { filterToggleProps, FilterPanelSlot } = useFilterPanelVisible();
    const dateFormat = 'YYYY-MM-DD HH:mm:ss';
    const navigate = useNavigate();
    const { RangePicker } = DatePicker;
    const [form1] = Form.useForm();
    const [limit, setLimit] = useState(20);
    const [page, setPage] = useState(1);
    let [num, setNum] = useState(0);
    const [channelType, setChannelType] = useState('');
    const [surveyId, setSurveyId] = useState('');
    const [treeData, setTreeData] = useState(null);
    const [startTime, setStartTime] = useState(' ');
    const [endTime, setEndTime] = useState('');
    const [dataSource, setDataSource] = useState(null);
    const [radioID, setRadioID] = useState('1');
    const [yesterday, setYesterday] = useState('');
    const [otherDay7, setOtherDay7] = useState('');
    const [otherDay30, setOtherDay30] = useState('');
    const [surveysData, setSurveysData] = useState([]);

    const tableRegionRef = useRef(null);
    const tableScrollContainerRef = useRef(null);
    const [scrollContainerVersion, setScrollContainerVersion] = useState(0);
    const [isFullscreen, setIsFullscreen] = useState(false);
    const enableTableScrollYLayout = useEnableTableScrollYLayout();
    const tableDeductSelectors = useMemo(() => ['.bi-channel-surveys-table-toolbar'], []);
    const tableScrollY = useTableScrollY(tableRegionRef, {
        enabled: enableTableScrollYLayout || isFullscreen,
        heightRootClassName: 'main-container-card',
        scrollYOffset: 0,
        deductSiblingSelectors: tableDeductSelectors,
    });

    useHorizontalScrollGuard(tableScrollContainerRef, {
        threshold: 6,
        edgeHoldMs: 220,
        watchValue: scrollContainerVersion,
    });
    useVerticalScrollShadow(tableScrollContainerRef, {
        threshold: 2,
        watchValue: scrollContainerVersion,
    });

    useLayoutEffect(() => {
        const region = tableRegionRef.current;
        if (!region) return;

        const resolveScrollContainer = () => {
            const next = region.querySelector('.ant-table-body') ?? region.querySelector('.ant-table-content');
            if (tableScrollContainerRef.current !== next) {
                tableScrollContainerRef.current = next;
                setScrollContainerVersion(v => v + 1);
            }
        };

        resolveScrollContainer();

        let rafId = 0;
        const mutationObserver = new MutationObserver(() => {
            if (rafId) cancelAnimationFrame(rafId);
            rafId = requestAnimationFrame(() => {
                rafId = 0;
                resolveScrollContainer();
            });
        });
        mutationObserver.observe(region, { childList: true, subtree: true });

        return () => {
            if (rafId) cancelAnimationFrame(rafId);
            mutationObserver.disconnect();
        };
    }, []);

    const handleToggleFullscreen = useCallback(() => {
        const target = document.querySelector('main.main-container');
        if (!target) return;
        const next = !target.classList.contains('is-page-fullscreen');
        target.classList.toggle('is-page-fullscreen', next);
        setIsFullscreen(next);
    }, []);

    useEffect(() => {
        const onKeyDown = e => {
            if (e.key !== 'Escape') return;
            const target = document.querySelector('main.main-container.is-page-fullscreen');
            if (!target) return;
            target.classList.remove('is-page-fullscreen');
            setIsFullscreen(false);
        };
        window.addEventListener('keydown', onKeyDown);
        return () => window.removeEventListener('keydown', onKeyDown);
    }, []);

    useEffect(() => {
        return () => {
            const target = document.querySelector('main.main-container.is-page-fullscreen');
            if (target) target.classList.remove('is-page-fullscreen');
        };
    }, []);

    function getBeforeDate(days) {
        var now = new Date().getTime();
        var ago = now - 86400000 * days; //一天的毫秒数为86400000
        var agoData = new Date(ago);
        var year = agoData.getFullYear();
        var mon = agoData.getMonth() + 1;
        var day = agoData.getDate();
        mon = mon < 10 ? '0' + mon : mon;
        day = day < 10 ? '0' + day : day;
        var date = year + '-' + mon + '-' + day;
        return date;
    }
    useEffect(() => {
        //   今天
        const day2 = new Date();
        day2.setTime(day2.getTime());
        const s2 = day2.getFullYear() + '-' + (day2.getMonth() + 1) + '-' + day2.getDate();
        setYesterday(getBeforeDate(0));
        setOtherDay7(getBeforeDate(7));
        setOtherDay30(getBeforeDate(30));
        console.log('昨天');
        const s1 = getBeforeDate(1);
        setStartTime(s1 + ' 00:00:00');
        setEndTime(s1 + ' 23:59:59');
        setNum(++num);
    }, []);
    const onChangeTreeSelect = value => {
        setChannelType(value || '');
    };
    const onReset = () => {
        setStartTime(getBeforeDate(1) + ' 00:00:00');
        setEndTime(getBeforeDate(1) + ' 23:59:59');
        setRadioID('1');
        setChannelType('');
        setSurveyId('');
        form1.resetFields();
        setPage(1);
        setNum(++num);
    };
    const columns = [
        {
            title: '渠道ID',
            dataIndex: 'channelId',
            key: 'channelId',
            align: 'center',
            width: 200,
        },

        {
            title: '渠道名称',
            dataIndex: 'title',
            align: 'center',
            width: 200,
            render: (_, record) => (
                <div className="channelBox">
                    <p className="channelBoxTitle">{record.title}</p>
                    <p style={{ color: '#666' }}>{record.type}</p>
                </div>
            ),
        },
        { title: '参与问卷人数', dataIndex: 'times', align: 'center', width: 300 },
        { title: '参与问卷医疗决策人人次', dataIndex: 'makerTimes', align: 'center', width: 300 },
    ];
    const onFinish = value => {
        setNum(++num);
    };
    function deepClone(result) {
        if (result && result.length) {
            result.forEach(item => {
                item.title = item.name;
                item.value = item.id;
                item.key = item.id;
                if (item.children.length) {
                    deepClone(item.children);
                }
            });
            return result;
        }
    }
    function getDaysBetween(dateString1, dateString2) {
        var startDate = Date.parse(dateString1);
        var endDate = Date.parse(dateString2);
        console.log(dateString1, dateString2);
        var days = (endDate - startDate) / (1 * 24 * 60 * 60 * 1000);
        return days;
    }
    const handleChangeTime = (value, dateString) => {
        setRadioID(5);
        if (value) {
            const day = getDaysBetween(dateString[0], dateString[1]);
            if (day >= 90) {
                message.info('时间区间不得超过90天');
            } else {
                setStartTime(dateString[0]);
                setEndTime(dateString[1]);
            }
        }
    };
    const handleChangeDate = (value, key) => {
        //今天的时间

        setRadioID(value.target.value);
        if (value.target.value == 1) {
            console.log('昨天');
            const s1 = getBeforeDate(1);
            setStartTime(s1 + ' 00:00:00');
            setEndTime(s1 + ' 23:59:59');
        } else if (value.target.value == 2) {
            setStartTime(otherDay7 + ' 00:00:00');
            setEndTime(yesterday + ' 23:59:59');
        } else {
            setStartTime(otherDay30 + ' 00:00:00');
            setEndTime(yesterday + ' 23:59:59');
        }
        console.log(startTime, endTime);
    };
    useEffect(() => {
        get('/channel/channel-group/listTree').then(
            res => {
                const result = deepClone(res.data);
                setTreeData(result);
            },
            err => {
                console.log(err);
            },
        );
    }, []);
    useEffect(() => {
        if (startTime && endTime) {
            get(`channel/channelsurveyreportdetail/page?channelType=${channelType}&surveyId=${surveyId}&pageSize=${limit}&page=${page}&startTime=${startTime}&endTime=${endTime}`).then(res => {
                if (res.status_code == 200) {
                    setDataSource(res.data);
                }
            });
        }
    }, [limit, page, num]);
    const changeCurrPage = useCallback(page => {
        setPage(page);
    }, []);
    const changePageSize = useCallback(pageSize => {
        setLimit(pageSize);
    }, []);
    const paginationProps = {
        ...fullPagerConfig,
        showSizeChanger: { placement: 'topRight' },
        current: page,
        pageSize: limit,
        size: 'small',
        total: dataSource && dataSource.totalCount,
        onShowSizeChange: (current, pageSize) => changePageSize(pageSize),
        onChange: page => {
            changeCurrPage(page);
        },
    };

    const disabledDate = current => {
        // return current > dayjs().endOf('day');
    };
    useEffect(() => {
        get('/survey/surveys/channel-surveys').then(res => {
            if (res && res.status_code === 200) {
                console.log(res);
                setSurveysData(res.data);
            }
        });
    }, []);
    const onChange = value => {
        setSurveyId(value || '');
    };
    const onSearch = value => {
        console.log('search:', value);
    };
    const filterOption = (input, option) => {
        const { name } = option.props.data;
        return name.toLowerCase().indexOf(input.toLowerCase()) >= 0;
    };

    const onRefresh = () => {
        setNum(n => n + 1);
    };

    return (
        <div className="page-container bi-channel-surveys-page">
            <PageHeader title="渠道问卷数据" breadcrumb={[{ label: '运营中心', path: '/operation/channels' }, { label: '渠道问卷数据' }]} {...filterToggleProps} />

            <FilterPanelSlot>
                <Card
                    size="small"
                    className="bi-channel-surveys-filter"
                    style={{
                        marginBottom: token.marginLG,
                        border: `1px solid ${token.colorBorderSecondary}`,
                        background: token.colorFillAlter,
                    }}
                >
                    <Form onFinish={onFinish} form={form1} autoComplete="off" requiredMark={false}>
                        <Row gutter={[16, 16]}>
                            <Col {...filterFormGridLayout}>
                                <Form.Item label="统计时间" style={filterFormItemStyle}>
                                    <div className="main-content-time">
                                        <Radio.Group onChange={handleChangeDate} value={radioID}>
                                            <Radio.Button value="1">昨日</Radio.Button>
                                            <Radio.Button value="2">最近7天</Radio.Button>
                                            <Radio.Button value="3">最近30天</Radio.Button>
                                        </Radio.Group>
                                    </div>
                                    <div className="main-content-time2">{<RangePicker showTime format={dateFormat} onChange={handleChangeTime} allowClear={false} disabledDate={disabledDate} value={[dayjs(startTime, dateFormat), dayjs(endTime, dateFormat)]} />}</div>
                                </Form.Item>
                            </Col>

                            <Col {...filterFormGridLayout}>
                                <Form.Item label="渠道分类" name="channelType" style={filterFormItemStyle}>
                                    {treeData && <TreeSelect allowClear={true} style={{ width: '100%' }} styles={{ popup: { root: { maxHeight: 400, overflow: 'auto' } } }} treeData={treeData} treeDefaultExpandAll={true} placeholder="选择渠道分类" onChange={onChangeTreeSelect} />}
                                </Form.Item>
                            </Col>

                            <Col {...filterFormGridLayout}>
                                <Form.Item label="调研问卷" name="surveyId" style={filterFormItemStyle}>
                                    <Select
                                        placeholder="请选择调研问卷"
                                        style={{ width: '100%' }}
                                        onChange={onChange}
                                        showSearch={{
                                            optionFilterProp: 'children',
                                            onSearch,
                                            filterOption: filterOption,
                                        }}
                                    >
                                        {surveysData
                                            && surveysData.map(item => (
                                                <Option key={item.id} value={item.id} data={item}>
                                                    {item.name}
                                                </Option>
                                            ))}
                                    </Select>
                                </Form.Item>
                            </Col>

                            <Col {...computeButtonColLayout(3)}>
                                <Form.Item label={<span>&nbsp;</span>} colon={false} style={filterFormItemStyle}>
                                    <Space size="small">
                                        <Button type="primary" htmlType="submit" icon={<i className="bi bi-search" aria-hidden="true" />}>
                                            检索
                                        </Button>
                                        <Button type="default" onClick={onReset}>
                                            重置
                                        </Button>
                                    </Space>
                                </Form.Item>
                            </Col>
                        </Row>
                    </Form>
                </Card>
            </FilterPanelSlot>

            <div ref={tableRegionRef} className="bi-channel-surveys-table-region">
                <div className="main-toolbar bi-channel-surveys-table-toolbar">
                    <div className="main-tools">
                        <span className="table-title">渠道列表</span>
                    </div>
                    <div className="sub-tools">
                        <Space>
                            <Tooltip title="刷新列表">
                                <Button type="default" onClick={onRefresh} icon={<span className="bi bi-arrow-clockwise" aria-hidden="true" />} aria-label="刷新列表" />
                            </Tooltip>
                            <Tooltip title={isFullscreen ? '退出全屏' : '全屏'}>
                                <Button type="default" onClick={handleToggleFullscreen} icon={<span className={isFullscreen ? 'bi bi-fullscreen-exit' : 'bi bi-fullscreen'} aria-hidden="true" />} aria-label={isFullscreen ? '退出全屏' : '全屏'} />
                            </Tooltip>
                        </Space>
                    </div>
                </div>

                <div className="bi-channel-surveys-table-wrap">
                    <Table
                        className={tableScrollY != null ? 'custom-table-scrollbar-always' : undefined}
                        rowKey="id"
                        columns={columns}
                        bordered
                        size="medium"
                        dataSource={dataSource?.list}
                        scroll={{
                            x: 'max-content',
                            ...(tableScrollY != null ? { y: tableScrollY } : {}),
                        }}
                        sticky
                        pagination={paginationProps}
                    />
                </div>
            </div>
        </div>
    );
}
